import {
  ChangeDetectionStrategy,
  Component,
  Input,
  SecurityContext,
  ViewEncapsulation,
} from '@angular/core';

import { ITranscriptWord } from '@models/grade-unit/transcript';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-word',
  templateUrl: './word.component.html',
  styleUrls: ['./word.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class WordComponent {
  @Input() public currentTime: number = 0;
  @Input() public wordList: ITranscriptWord[] = [];

  constructor(private domSanitizer: DomSanitizer) {}
  public get htmlFormattedText(): SafeHtml {
    const wordArray: string[] = ['<p class="m-0">'];
    for (const word of this.wordList) {
      const wordClass: string = this.applyWordStylingAsString(word) || '';
      wordArray.push(`<span class="word ${wordClass}">${word.content}</span>`);
    }
    wordArray.push('</p>');
    const rawHtml = wordArray.join(' ');
    return this.domSanitizer.sanitize(SecurityContext.HTML, rawHtml);
  }

  private applyWordStylingAsString(word: ITranscriptWord): string {
    const classes: string[] = [];
    if (
      this.currentTime <= parseFloat(word.end) &&
      this.currentTime > parseFloat(word.start)
    )
      classes.push('highlight');
    if (word.isBold) classes.push('emphatic');
    if (word.isItalicized) classes.push('italic');
    if (word.isBlue) classes.push('prompt');
    if (word.isHighlighted) classes.push('highlightedBlue');
    return classes.join(' ');
  }

  public shouldApplyWordStyling(word: ITranscriptWord): {
    highlight: boolean;
    emphatic: boolean;
    italic: boolean;
    prompt: boolean;
    highlightedBlue: boolean;
  } {
    return {
      highlight:
        this.currentTime <= parseFloat(word.end) &&
        this.currentTime > parseFloat(word.start),
      emphatic: word.isBold,
      italic: word.isItalicized,
      prompt: word.isBlue,
      highlightedBlue: word.isHighlighted,
    };
  }
}
